import { ButtonLink } from './Button';
import { Container } from './Section';
import { Icon } from '../lib/icons';

export function CTASection({
  title = "What's slowing your team down?",
  body = 'Tell us what is manual, fragile, unclear, or hard to support. We will respond with practical next steps and a realistic path forward.',
  button = 'Schedule a Consultation'
}: {
  title?: string;
  body?: string;
  button?: string;
}) {
  return (
    <section className="bg-brand-dark py-20 text-white">
      <Container>
        <div className="relative overflow-hidden rounded-lg border border-white/10 bg-brand-dark p-8 shadow-soft sm:p-10 lg:p-12">
          <div className="absolute inset-0 dot-field opacity-20" />
          <div className="relative grid gap-8 lg:grid-cols-[1fr_auto] lg:items-center">
            <div>
              <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-brand-teal">Fast Clarity</p>
              <h2 className="mt-3 font-display text-4xl leading-tight sm:text-5xl">{title}</h2>
              <p className="mt-4 max-w-2xl text-lg leading-8 text-white/75">{body}</p>
              <div className="mt-6 flex flex-wrap gap-3">
                {['business automation Massachusetts', 'managed hosting Massachusetts', 'network cleanup Massachusetts'].map(
                  (item) => (
                    <span
                      key={item}
                      className="inline-flex items-center gap-2 rounded-full border border-brand-teal/40 px-4 py-2 text-sm text-white/80"
                    >
                      <Icon name="check" className="h-4 w-4 text-brand-teal" />
                      {item}
                    </span>
                  )
                )}
              </div>
            </div>
            <ButtonLink to="/booking" className="w-full sm:w-auto" variant="primary">
              {button}
            </ButtonLink>
          </div>
        </div>
      </Container>
    </section>
  );
}
